let clientReady = false;

export default {
    beforeCreate: function () {
        this.$expiviReady = new Promise(resolve => {
            window.expivi._events.onReady
                .subscribe(() => {
                    if (clientReady === false) {
                        window.expivi._dispatch('client_ready').then(() => {
                            clientReady = true
                            resolve(window.expivi)
                        })
                    } else {
                        resolve(window.expivi)
                    }
                })
        })
    }
}
